import qs from 'qs';
import { useMemo } from 'react';
import { transformKeysToLower } from '../utils/object';

export default function useURLSearchParams(search, { caseInsensitive = false } = {}) {
	return useMemo(() => {
		const normalizedSearch = search.replace('?', '');
		const parsedObj = qs.parse(normalizedSearch, {
			comma: true,
			allowDots: true,
		});

		return caseInsensitive ? transformKeysToLower(parsedObj) : parsedObj;
	}, [caseInsensitive, search]);
}
